import { SUPPORTED_LANGS, isLang, type Lang } from "@majourneys/shared";

/**
 * Given the browser's ordered language preferences (`navigator.languages`) and
 * the language currently shown (from the URL), returns the visitor's most
 * preferred SUPPORTED language **if it differs** from the current one — i.e.
 * the language we should suggest. Returns null when the current language is
 * already their best supported preference, or none of their preferences are
 * supported.
 *
 * Region subtags are stripped: `fr-FR` and `fr-CA` both map to `fr`.
 */
export function pickPreferredLang(
  navigatorLangs: readonly string[] | undefined,
  currentLang: string,
): Lang | null {
  if (!navigatorLangs?.length) return null;
  for (const raw of navigatorLangs) {
    const base = raw.split("-", 1)[0]?.toLowerCase();
    if (!base || !isLang(base)) continue;
    // The visitor's top supported preference is already shown — nothing to suggest.
    if (base === currentLang) return null;
    return base;
  }
  return null;
}

/** Re-exported for callers that need the supported set without a second import. */
export { SUPPORTED_LANGS };
